export const generativeAiStandardsRunUsage = "/:app_group_id/generative_ai/standards_run_usage";
